import sample_1 from './100_19186.jpg';
import sample_2 from './100_19503.jpg';

export const olympModernFitImpressions = {
    sample_1,
    sample_2,
};
